/**
 * Download pdf from base64 string.
 * @param pdfString - base64 string of pdf.
 */
export function downloadPdf(pdfString: string) {
    if (!pdfString) return console.log("no pdf string.");
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${pdfString}`;
    link.download = "PremiumFinanceAgreement.pdf";;
    link.click();
}
